import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { map, Observable } from 'rxjs';

import { IAppRootState } from '../../core/store';
import { SemanticRuleItemEntity } from '../components/semantic-rule-list/semantic-rule-item.entity';
import { SemanticRuleListEntity } from '../components/semantic-rule-list/semantic-rule-list.entity';
import {
	SemanticRuleState,
	SemanticRuleFeatureKey,
} from './semantic-rule.state';

interface SemanticRuleRootState extends IAppRootState {
	[SemanticRuleFeatureKey]: SemanticRuleState;
}

@Injectable()
export class SemanticRuleSelector {
	public constructor(private readonly store: Store<SemanticRuleRootState>) {}

	private get state(): Observable<SemanticRuleState> {
		return this.store.pipe(select((store) => store[SemanticRuleFeatureKey]));
	}
	public getLoading$(): Observable<boolean> {
		return this.state.pipe(map((state) => state.get('loading')));
	}

	public getSemanticRuleList$(): Observable<SemanticRuleListEntity> {
		return this.state.pipe(map((state) => state.get('semanticRuleList')));
	}

	public getSelectedSemanticRules$(
		selected: Array<string>
	): Observable<Array<SemanticRuleItemEntity>> {
		return this.getSemanticRuleList$().pipe(
			map((list) =>
				selected.reduce<Array<SemanticRuleItemEntity>>((acc, curr) => {
					const maybe = list.elements.get(`${curr}`);
					if (maybe) {
						acc.push(maybe);
						return acc;
					}
					return acc;
				}, [])
			)
		);
	}
}
